__turbopack_context__.v({
  "cell--right": "render-html-module-scss-module__X_vAQW__cell--right",
  "wrapper": "render-html-module-scss-module__X_vAQW__wrapper",
});
